import { Card, Statistic } from 'antd';
import { useNavigate } from 'react-router-dom';

export interface TodoStatCardProps {
  title: string;
  value: number;
  /** 点击跳转的目标路由；不传则不可点击 */
  to?: string;
  /** 有待办时红色高亮（逾期/高风险等强提醒） */
  danger?: boolean;
  suffix?: string;
}

/**
 * 概览「今日待办」通用计数卡（37 号概览页改造）：
 * 展示单个待办计数，点击直达对应列表页；danger 项在值 > 0 时红色高亮。
 * 纯展示组件，不发起任何请求。
 */
export function TodoStatCard({
  title,
  value,
  to,
  danger,
  suffix = '条',
}: TodoStatCardProps): React.ReactElement {
  const navigate = useNavigate();

  const statistic = (
    <Statistic
      title={title}
      value={value}
      suffix={suffix}
      valueStyle={danger && value > 0 ? { color: '#D95C5C' } : undefined}
    />
  );

  if (!to) {
    return (
      <Card size="small" variant="outlined" style={{ minWidth: 150 }}>
        {statistic}
      </Card>
    );
  }

  return (
    <Card
      size="small"
      hoverable
      variant="outlined"
      style={{ minWidth: 150, cursor: 'pointer' }}
      onClick={() => navigate(to)}
    >
      {statistic}
    </Card>
  );
}
